import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['links', 'template', 'answerContainer', 'answerFieldsContainer', 'radio', 'destroy'];
  editPage = '';

  connect() {
    if (this.isEditPage()) {
      if (this.category() !== 'free_text') {
        this.editPage = 'choices';
        this.toggleAnswers();
      } else {
        this.answerContainerTarget.style.visibility = 'hidden';
        this.linksTarget.style.visibility = 'hidden';

        this.answerFieldsContainerTarget
          .querySelectorAll('.nested-fields')
          .forEach((field) => {
            const destroyInput = field.querySelector("input[name*='_destroy']");
            const isNewRecord = field.dataset.newRecord === "true";

            if (isNewRecord) {
              field.style.display = "none";
            } else {
              destroyInput.value = 1;
              field.style.display = "none";
            }
          });
      }
    } else {
      this.toggleAnswers();
    }
  }

  category() {
    let selected = this.radioTargets.find((el) => el.checked);
    return selected ? selected.value : null;
  }

  toggleAnswers() {
    if (this.category() === 'free_text') {
      this.answerContainerTarget.style.visibility = 'hidden';
      this.linksTarget.style.visibility = 'hidden';

      this.answerFieldsContainerTarget
        .querySelectorAll('.nested-fields')
        .forEach((field) => {
          const destroyInput = field.querySelector("input[name*='_destroy']");
          const isNewRecord = field.dataset.newRecord === "true";

          if (isNewRecord) {
            destroyInput.value = 0;
            field.style.display = "none";
          } else {
            destroyInput.value = 1;
            field.style.display = "none";
          }
        });
    } else {
      this.answerContainerTarget.style.visibility = 'visible';
      this.linksTarget.style.visibility = 'visible';

      if ( this.editPage === 'choices' ) {
        this.answerFieldsContainerTarget
          .querySelectorAll('.nested-fields')
          .forEach((field) => {
            const destroyInput = field.querySelector("input[name*='_destroy']");
            destroyInput.value = 0;
            field.style.display = "block";
        });
      } else {
        this.answerFieldsContainerTarget
        .querySelectorAll('.nested-fields')
        .forEach((field) => {
          const destroyInput = field.querySelector("input[name*='_destroy']");
          const isNewRecord = field.dataset.newRecord === "true";

          if (isNewRecord) {
            destroyInput.value = 0;
            field.style.display = "block";
          } else {
            destroyInput.value = 1;
            field.style.display = "none";
          }
        });
      }
    }
  }

  add(event) {
    event.preventDefault();
    const content = this.templateTarget.innerHTML.replace(
      /NEW_RECORD/g,
      new Date().getTime()
    );
    this.linksTarget.insertAdjacentHTML('beforebegin', content);
  }

  remove(event) {
    event.preventDefault();
    let wrapper = event.target.closest('.nested-fields');
    let nue = wrapper.dataset.newRecord === 'true';
    if (nue) {
      wrapper.remove();
    } else {
      wrapper.querySelector("input[name*='_destroy']").value = 1;
      wrapper.style.display = 'none';
    }
  }

  isEditPage() {
    return window.location.pathname.includes('/edit');
  }
}
